import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  styled,
  Grow,
} from "@mui/material";
import { Button } from "antd";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SendIcon from "@mui/icons-material/Send";
import CloseIconMUI from "@mui/icons-material/Close";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import TextFieldStyled from "@/components/detailed-form/components/TextFieldStyled";
import EmailValidator from "@/components/email-validator";
import MobileNumberValidator from "@/components/mobile-number-validator";
import PostcodeAddressEquifax from "@/components/postcode-address/postcode-address-equifax";
import {
  DISCORD_BOTS,
  showToast,
  triggerDiscordMessage,
  handleClaimUpsert as updateClaim,
  handleZohoUpsert,
  GET_API_BASE_URL,
  convertPhoneToUKFormat,
} from "@/app/utils/functions";
import { useLocalStorage } from "@/components/detailed-form/utils/hooks";
import useWindowSize from "@/app/utils/useWindowSize";
import axios from "axios";
import { useFeedbackDialog } from "@/context/feedbackDialog.context";
import "./style.scss";
import { CloseOutlined } from "@mui/icons-material";

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#00B86A",
  color: "#FFFFFF",
  display: "flex",
  textTransform: "none",
  fontWeight: 700,
  marginTop: "10px",
  width: "100%",
  "&:hover": {
    background: "#00B86A",
    color: "#FFFFFF",
  },
  "&:active": {
    background: "#00B86A",
    color: "#FFFFFF",
  },
  "&:focus": {
    background: "#00B86A",
    color: "#FFFFFF",
  },
}));

const IssueButton = styled(StyledButton)(({ theme }) => ({
  background: "#ffffff",
  color: "#000",
  justifyContent: "space-between",
  fontWeight: 500,
  marginBottom: "0",
  borderColor: "#000",
  padding: "20px 15px",
  "&:hover": {
    background: "#00B86A",
    color: "#FFFFFF",
  },
}));

const FeedbackDialog = ({ isFloating = false }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [actionValue, setActionValue] = useState("");
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [selectedIssue, setSelectedIssue] = useState({});
  const { loadFromStorage, saveToStorage } = useLocalStorage();
  const [size] = useWindowSize();

  const { openIssueId, setOpenIssueId } = useFeedbackDialog();

  const toggleDialog = () => {
    setDialogOpen(!dialogOpen);
    setFeedback(dialogOpen ? "" : feedback);
    setEmailOrPhone(dialogOpen ? "" : emailOrPhone);
    dialogOpen && setSelectedIssue({});
    if (openIssueId) {
      setOpenIssueId(null);
    }
  };

  const sendFeedbackToZoho = (description) => {
    const lSInfo = loadFromStorage("userAnswers");
    const claimNumber = loadFromStorage("currentId");
    if (lSInfo?.basicInfo?.yourEmail) {
      axios.post("https://v2be.fair.inc/zoho-feedback", {
        email: `${lSInfo?.basicInfo?.yourEmail}`,
        feedback: description,
        name: `${lSInfo?.basicInfo?.givenName} ${lSInfo?.basicInfo?.surname}${
          claimNumber ? ` - [${claimNumber}]` : ""
        }`,
        contact: `${lSInfo?.basicInfo?.yourPhone}`,
      });
    }
  };

  const handleSubmit = () => {
    toggleDialog();
    try {
      const claimNumber = loadFromStorage("currentId");
      const lSInfo = loadFromStorage("userAnswers");
      triggerDiscordMessage({
        bot: DISCORD_BOTS.FEEDBACK,
        content: `# Claim Number: ${claimNumber}
                  - Name: **${lSInfo?.basicInfo?.givenName} ${lSInfo?.basicInfo?.surname}**
            - **Feedback:** ${feedback}
            `,
      });
      updateClaim({
        feedback_submitted: true,
        feedback: feedback,
      });
      sendFeedbackToZoho(feedback);
      setFeedback("");
      setSelectedIssue({});
      setActionValue("");
      showToast("Thank you, your feedback has been submitted.", "success");
    } catch (e) {
      // console.log("Unable to submit feedback", e);
      // console.log("Feedback:", feedback);
    }
  };

  const handleIssueClick = (id) => {
    let tempSelectedIssue = {};
    setActionValue("");
    commonIssues.forEach((issue) => {
      if (issue.id === id) {
        tempSelectedIssue = issue;
      }
    });
    if (tempSelectedIssue.id) {
      setSelectedIssue(tempSelectedIssue);
    }
  };

  const handleIssueSubmit = () => {
    const claimNumber = loadFromStorage("currentId");
    if (selectedIssue.id) {
      if (selectedIssue.action?.isFeedback) {
        if (feedback && feedback !== "") {
          handleSubmit();
        } else {
          alert("Please enter your issue before submitting");
        }
      } else {
        if (selectedIssue?.action?.onClick) {
          selectedIssue?.action?.onClick();
        } else {
          if (selectedIssue?.action?.id && actionValue && actionValue !== "") {
            if (selectedIssue?.action?.localId) {
              const lSInfo = loadFromStorage("userAnswers");
              // selectedIssue?.action?.localId && (!(loadFromStorage("userAnswers")?.basicInfo[selectedIssue?.action?.localId]))
              if (lSInfo && lSInfo.basicInfo) {
                saveToStorage("userAnswers", {
                  basicInfo: {
                    ...lSInfo.basicInfo,
                    [selectedIssue?.action?.localId]: actionValue,
                  },
                });
              } else {
                saveToStorage("userAnswers", {
                  basicInfo: {
                    [selectedIssue?.action?.localId]: actionValue,
                  },
                });
              }
              if (selectedIssue?.action?.id === "phone_number") {
                handleZohoUpsert({
                  Phone: actionValue,
                });
                if (window.location.pathname.includes("/submit-claim")) {
                  const idvUrlSMS = `${GET_API_BASE_URL()}/sms`;
                  const sendSMSPayload = {
                    phoneNumber: convertPhoneToUKFormat(actionValue),
                    idvLink: `https://www.fair.inc/get-started/id-selfie-upload?id=${claimNumber}&chase_source=sms`,
                    smsType: "idv",
                  };
                  /** NOTE: UNCOMMENT THE BELOW CODE TO SEND SMS USING TWILLIO */
                  // axios.post(
                  //   idvUrlSMS, sendSMSPayload,{ withCredentials: true }
                  // ).catch(e => {
                  //   console.error("ERROR sending IDV SMS", e);
                  // });
                  setTimeout(() => {
                    handleZohoUpsert(
                      {
                        Changed_Phone_No: true,
                      },
                      "contact"
                    );
                  }, 1000);
                }
              }
            }
            updateClaim({
              [selectedIssue?.action?.id]: actionValue,
              feedback_action: `${selectedIssue.title} (${actionValue})`,
            });
            showToast(
              `Thank you, your request to ${selectedIssue?.title} has been submitted.`,
              "success"
            );
            const lSInfo = loadFromStorage("userAnswers");
            triggerDiscordMessage({
              bot: DISCORD_BOTS.FEEDBACK,
              content: `# Claim Number: ${claimNumber}
                        - Name: **${lSInfo?.basicInfo?.givenName} ${lSInfo?.basicInfo?.surname}** 
                        - **Issue Action:** ${selectedIssue.title}
                        - **Value:** ${actionValue}
                      `,
            });
            setActionValue("");
            setSelectedIssue({});
            toggleDialog();
          } else {
            alert(`Please enter a valid value to proceed`);
          }
        }
      }
    } else {
      alert("Please select an issue to proceed");
    }
  };

  const validIssueIds = [-1, ...commonIssues?.map((issue) => issue.id)]; // -1 is just to open the dialog

  useEffect(() => {
    if (openIssueId && validIssueIds.includes(openIssueId)) {
      setDialogOpen(true);
      setFeedback("");
      setEmailOrPhone("");
      setSelectedIssue({});
      if (openIssueId !== -1) {
        handleIssueClick(openIssueId);
      }
    }
  }, [openIssueId]);

  return (
    <div
      className={`fixed transition-all duration-500 bottom-0 right-0 h-screen w-screen flex flex-col items-center md:items-end justify-start md:justify-end ${
        dialogOpen ? "backdrop-brightness-75" : ""
      }`}
      style={{
        zIndex: 1102,
        pointerEvents: dialogOpen ? "auto" : "none",
        paddingTop: "100px",
        overflow: "hidden",
      }}
    >
      <div
        style={{ pointerEvents: "auto", overflow: "auto" }}
        className="flex flex-col items-center md:items-end justify-end pb-4 gap-3 w-full feedback-inner-container"
      >
        {dialogOpen && (
          <Grow in={true} timeout={500}>
            <Card
              sx={{
                overflowY: "auto",
                width: {
                  md: "400px",
                  xs: "100%",
                },
                boxShadow:
                  "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;",
              }}
            >
              <CardContent
                sx={{
                  "&.MuiCardContent-root:last-child": {
                    paddingBottom: "16px",
                  },
                }}
              >
                <div
                  className="text-lg"
                  style={{
                    background: "#00B86A",
                    color: "white",
                    fontWeight: 600,
                    marginLeft: "-16px",
                    marginRight: "-16px",
                    marginTop: "-16px",
                    marginBottom: "16px",
                    padding: "0px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingLeft: "16px",
                    paddingRight: "10px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  {" "}
                  <>
                    {selectedIssue.id
                      ? selectedIssue.title
                      : `How can we help?`}{" "}
                  </>
                  <Button
                    onClick={toggleDialog}
                    style={{
                      height: "44px",
                      width: "44px",
                      borderRadius: "12px",
                    }}
                  >
                    <CloseOutlined />
                  </Button>
                </div>
                {/* @ts-ignore */}
                {selectedIssue.id && (
                  <div id="feedback-dialog--issue">
                    <Button
                      onClick={() => setSelectedIssue({})}
                      variant="outline"
                      sx={{
                        marginBottom: "0px !important",
                        paddingLeft: "0px",
                        marginLeft: "-5px",
                        textTransform: "none",
                        fontWeight: 700,
                        color: "#1e7c54",
                        background: "#fff",
                      }}
                    >
                      <KeyboardArrowLeftIcon sx={{ fill: "currentColor" }} />
                      Back
                    </Button>
                    {selectedIssue.maskTitle && (
                      <Typography
                        variant="h4"
                        sx={{
                          marginBottom: "16px",
                          color: "#2c2c2c",
                        }}
                      >
                        {selectedIssue.maskTitle}
                      </Typography>
                    )}
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: "#2c2c2c !important",
                        fontWeight: 500,
                      }}
                    >
                      {selectedIssue.solution}
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        marginBottom: "24px",
                      }}
                    >
                      {selectedIssue.type === "input" && (
                        <div>
                          {selectedIssue.inputType === "tel" && (
                            <MobileNumberValidator
                              variant="outlined"
                              hideLabel
                              placeholder={selectedIssue.placeholder}
                              sx={{
                                width: "100%",
                                "& .MuiInputBase-input": {
                                  textTransform: "none",
                                },
                              }}
                              onVerified={(value) => {
                                if (value) {
                                  setActionValue(value);
                                }
                              }}
                              size="small"
                            />
                          )}
                          {selectedIssue.inputType === "email" && (
                            <EmailValidator
                              onVerified={(value) => {
                                if (value) {
                                  setActionValue(value);
                                }
                              }}
                              hideLabel={true}
                              autoFocus={false}
                              value={actionValue}
                              size="small"
                            />
                          )}
                          {selectedIssue.inputType === "postcode" && (
                            <PostcodeAddressEquifax
                              onAddressSelect={(value) => {
                                if (value) {
                                  setActionValue(value);
                                }
                              }}
                              placeholder={selectedIssue.placeholder}
                              hideLabel={true}
                              autoFocus={false}
                              value={actionValue}
                              size="small"
                            />
                          )}
                          {selectedIssue.inputType === "text" && (
                            <TextFieldStyled
                              variant="outlined"
                              placeholder={selectedIssue.placeholder}
                              sx={{
                                width: "100%",
                                "& .MuiInputBase-input": {
                                  textTransform: "none",
                                },
                              }}
                              value={actionValue}
                              onChange={(e) => setActionValue(e.target.value)}
                            />
                          )}
                          {selectedIssue.inputType === "text" && (
                            <TextFieldStyled
                              variant="outlined"
                              placeholder={selectedIssue.placeholder}
                              sx={{
                                width: "100%",
                                "& .MuiInputBase-input": {
                                  textTransform: "none",
                                },
                              }}
                              value={actionValue}
                              onChange={(e) => setActionValue(e.target.value)}
                            />
                          )}
                          {selectedIssue.inputType ===
                            "text-describe-issue" && (
                            <TextFieldStyled
                              multiline={true}
                              variant="outlined"
                              rows={3}
                              placeholder="Describe your issue..."
                              sx={{
                                width: "100%",
                                "& .MuiInputBase-input": {
                                  textTransform: "none",
                                },
                              }}
                              value={feedback}
                              onChange={(e) => setFeedback(e.target.value)}
                              size="small"
                            />
                          )}
                          <StyledButton
                            variant="contained"
                            startIcon={<SendIcon />}
                            onClick={() => {
                              handleIssueSubmit();
                            }}
                          >
                            Submit
                          </StyledButton>
                        </div>
                      )}
                      {selectedIssue.type === "link" && (
                        <Button
                          variant="contained"
                          onClick={selectedIssue.action.onClick}
                        >
                          {selectedIssue.action.text}
                        </Button>
                      )}
                    </div>
                  </div>
                )}
                {!selectedIssue?.id && (
                  <div id="feedback-dialog--content">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        marginBottom: "24px",
                      }}
                    >
                      {commonIssues.map((issue) => (
                        <IssueButton
                          key={issue.id}
                          id={issue.eleId || `feedback_popup_${issue.id}`}
                          variant="contained"
                          onClick={() => handleIssueClick(issue.id)}
                        >
                          {issue.title}
                          <KeyboardArrowRightIcon />
                        </IssueButton>
                      ))}
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          </Grow>
        )}
      </div>
    </div>
  );
};

export default FeedbackDialog;

const commonIssues = [
  {
    id: 1,
    eleId: "will-it-cost-faq",
    title: "Will it cost me anything?",
    type: "message",
    solution: (
      <div>
        <p style={{ marginBottom: "10px" }}>
          {`Our agreements are `}
          <b style={{ textDecoration: "underline" }}>{`No Win No Fee!`}</b>
        </p>
        <p
          style={{}}
        >{`Our service charge is up to a maximum capped amount of 15-30% plus VAT of the total amount we recover for you, and if your claim is unsuccessful you won’t have to pay a penny. However, if you cancel our agreement after the 14 day cooling off period, a cancellation fee of £50 per hour is payable (up to a maximum of 18 hours).`}</p>
      </div>
    ),
  },
  {
    id: 2,
    eleId: "dont-know-lender-feedback",
    title: "I can't remember my lender",
    type: "message",
    solution:
      "Don't worry, all you need to do is complete a short online form and we can find your vehicle finance lenders from the past 12 years!",
  },
  {
    id: 3,
    eleId: "change-number-feedback",
    title: "Update My Phone Number",
    type: "input",
    inputType: "tel",
    placeholder: "Enter new phone number",
    solution: "Please enter your new mobile number below:",
    action: {
      id: "phone_number",
      localId: "yourPhone",
    },
  },
  {
    id: 4,
    eleId: "website-feedback-form",
    title: "Report a Technical Problem",
    maskTitle: "Having Issues?",
    type: "input",
    inputType: "text-describe-issue",
    solution: (
      <>
        <p style={{ marginBottom: "10px" }}>
          We hope you're not experiencing any technical issues on our site, but
          on the off-chance you are, please use this form to report the problem.
        </p>
        <p style={{}}>
          <strong>Important:</strong> This form is{" "}
          <strong>not monitored by our customer service team.</strong>
          If you have any questions regarding our services, or you would like an
          update on your claim, please contact our customer service team by
          emailing us at{" "}
          <a
            style={{ fontWeight: "600", color: "#1e7c54" }}
            href="mailto:claims@fair.inc"
          >
            claims@fair.inc
          </a>
        </p>
      </>
    ),
    action: {
      isFeedback: true,
    },
  },
  // {
  //   id: 2,
  //   eleId: 'change-email-feedback',
  //   title: "Change Email",
  //   type: "input",
  //   inputType: "email",
  //   placeholder: "Enter new email address",
  //   solution: "Please enter your new email address below:",
  //   action: {
  //     id: "email",
  //     localId: "yourEmail",
  //   },
  // },
  // {
  //   id: 3,
  //   eleId: 'add-prev-address-feedback',
  //   title: "Add Previous Address",
  //   type: "input",
  //   inputType: "postcode",
  //   placeholder: "Enter previous address",
  //   solution: "Please enter your postcode of previous address below:",
  //   action: {
  //     id: "previousAddresses",
  //     localId: "previousAddresses",
  //   },
  // },
  // {
  //   id: 4,
  //   title: 'Problems with uploading ID',
  //   type: 'link',
  //   solution: 'To get things started you can upload your ID using the link below:',
  //   action: {
  //     text: 'Upload ID Document',
  //     onClick: () => window.open('/upload-id', '_blank')
  //   }
  // },
  // {
  //   id: 5,
  //   title: "Problems with Postcode",
  //   type: "message",
  //   solution:
  //     "All valid U.K. postcodes are recognized, please check again to ensure your entry is correct.",
  // },
];
